<template>
  <div class="main-container">
    <h1 class="medium-h1">{{$t('faq.title')}}</h1>
    <div class="tab">
      <input type="checkbox" name="accordion-1" id="cb1">
      <label for="cb1" class="tab__label">{{$t('faq.q1')}}</label>
      <div class="tab__content">
        <p>{{$t('faq.a1')}}</p>
      </div>
    </div>
    <div class="tab">
      <input type="checkbox" name="accordion-1" id="cb2">
      <label for="cb2" class="tab__label">{{$t('faq.q2')}}</label>
      <div class="tab__content">
        <p>{{$t('faq.a2')}}</p>
      </div>
    </div>
    <div class="tab">
      <input type="checkbox" name="accordion-1" id="cb3">
      <label for="cb3" class="tab__label">{{$t('faq.q3')}}</label>
      <div class="tab__content">
        <p>{{$t('faq.a3')}}</p>
      </div>
    </div>
    <div class="tab">
      <input type="checkbox" name="accordion-1" id="cb4">
      <label for="cb4" class="tab__label">{{$t('faq.q4')}}</label>
      <div class="tab__content">
        <p>{{$t('faq.a4')}}</p>
      </div>
    </div>
    <div class="tab">
      <input type="checkbox" name="accordion-1" id="cb5">
      <label for="cb5" class="tab__label">{{$t('faq.q5')}}</label>
      <div class="tab__content">
        <p>{{$t('faq.a5')}}</p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CarousselComponent',
  components: {

  },
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-container {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  gap: 10px;

}


/* Core styles/functionality */
.tab {
  position: relative;
  width: 100%;
}
.tab input {
  position: absolute;
  opacity: 0;
  z-index: -1;
}
.tab__content {
  max-height: 0;
  overflow: hidden;
  transition: all 0.35s;
}
.tab input:checked ~ .tab__content {
  max-height: 10rem;
}

/* Visual styles */
.accordion {
  color: var(--theme);
  border: 2px solid;
  border-radius: 0.5rem;
  overflow: hidden;
}
.tab__label,
.tab__close {
  display: flex;
  color: white;
  background: var(--theme);
  cursor: pointer;
}
.tab__label {
  border-radius: 25px;
  border: 1px solid #5294ff3d;
  box-shadow: inset 0px 0px 14px 0px rgba(82, 148, 255, 0.106);
/*   background: rgb(46,126,254); */
background: linear-gradient(130deg, rgba(46,126,254,0.2) -90%, rgba(151,86,86,0) 50%, rgba(46,126,254,0.2) 190%);
  color: white;
  justify-content: space-between;
  font-weight: 900;
  padding: 1rem;
}
.tab__label::after {
  content: "\276F";
  width: 1em;
  height: 1em;
  text-align: end;
  transform: rotate(90deg);
  transition: all 0.35s;
}
.tab input:checked + .tab__label::after {
    transform: rotate(270deg);
    text-align: start;
}
.tab__content p {
  margin: 0;
    padding-bottom: 1rem;
  padding-right: 1rem;
    padding-left: 1rem;
}
.tab__close {
  justify-content: flex-end;
  padding: 0.5rem 1rem;
  font-size: 0.75rem;
}
.accordion--radio {
  --theme: var(--secondary);
}

/* Arrow animation */
.tab input:not(:checked) + .tab__label:hover::after {
  animation: bounce .5s infinite;
}
@keyframes bounce {
  25% {
    transform: rotate(90deg) translate(.25rem);
  }
  75% {
    transform: rotate(90deg) translate(-.25rem);
  }
}

</style>
